module.exports = __webpack_public_path__ + "img/interface-2_jp.3c1f51c.jpg";